import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';

const Local = (props) => {


    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchLocais()
    }

    const editar = async (id) => {
        props.editar(id)
    }
    return (
        <Fragment>
            <Col>
                <Card className='card-list'>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>{props.local.nome} </Card.Title>
                        <p>{props.local.secretaria}</p>
                        <p>Endereco: {props.local.endereco}</p>
                        <p>Horários: {props.local.horarios}</p>
                        <p>Telefone: {props.local.telefone}</p>
                        {props.local.telefonePlantao ? <p>Telefone do Plantão: {props.local.telefonePlantao}</p> : null}
                        {props.local.email ? <p>E-mail: {props.local.email}</p> : null}
                        <p>Responsável: {props.local.responsavel}</p>
                        <p>Descrição: {props.local.descricao}</p>
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.local._id)} variant='primary'>Editar</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.local._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Local;